var _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNftIcon = function SvgNftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "full",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
    alignmentBaseline: "middle",
    fill: "#a9a9a9",
    fontFamily: "Arial",
    fontSize: 40,
    textAnchor: "middle",
    x: "50%",
    y: "50%"
  }, "NFT")));
};
export default SvgNftIcon;